import { AxiosResponse } from 'axios'
import { Reason, Reasons } from '@/domain/entities/MasterData'
import { Utils } from '@/app/infrastructures/misc'
import { ReasonResponseInterface } from '@/data/responses/contracts/MasterDataResponseInterface'

export class MasterDataMapper {
  convertResponseListReasonFromApi(result: AxiosResponse): Reasons {
    const {
      data: { data },
    } = result

    return new Reasons(
      (data || []).map((item: ReasonResponseInterface) => {
        return Utils.toInstance(new Reason(), JSON.stringify(item))
      })
    )
  }
}
